import React from "react";
import { format } from "date-fns";
import en from "date-fns/locale/en";
import pl from "date-fns/locale/pl";
import { useTranslation } from "react-i18next";

import { ArrowIcon, WeatherIcon } from "../../../common/index";
import { getWeatherIconName, getTemperature } from "../Property";

import "./WeatherConditions.scss";

const langs = {
  pl,
  gb: en,
};

const WeatherConditions = ({ property, onDaySelect }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation("tools");
  const { forecast } = property;

  return (
    <div className="WeatherConditions">
      {forecast
        .slice(0, 5)
        .map(
          ({
            id,
            at_date,
            weather_hourly,
            average_daytime_temperature,
            average_nighttime_temperature,
          }) => (
            <div className="WeatherConditions__list" key={id}>
              <div className="WeatherConditions__list__weekday">
                {format(at_date, "dddd", { locale: langs[language] })}
              </div>
              <div className="WeatherConditions__list__day">
                {typeof average_daytime_temperature === "number" && (
                  <>
                    {t("tools:weather.day")}{" "}
                    <b>{Math.round(average_daytime_temperature)}°C</b>
                  </>
                )}
              </div>
              <div className="WeatherConditions__list__night">
                {typeof average_nighttime_temperature === "number" && (
                  <>
                    {t("tools:weather.night")}{" "}
                    <b>{Math.round(average_nighttime_temperature)}°C</b>
                  </>
                )}
              </div>
              <div className="WeatherConditions__list__icon">
                <WeatherIcon
                  forecast={
                    getWeatherIconName(weather_hourly) || "partly-cloudy-day"
                  }
                  size={64}
                  color="#00965E"
                />
              </div>
              <div className="WeatherConditions__list__action">
                <ArrowIcon
                  color="#00965E"
                  onClick={() => onDaySelect(at_date, property.name)}
                />
              </div>
            </div>
          )
        )}
    </div>
  );
};

export default WeatherConditions;
